@use '@lib/assets/styles/main.scss' as *;

.root {
  position: relative;
}

.sticky {
  position: sticky;
  top: $dashboardLayoutHeaderHeight;
  z-index: $zIndexStickyHeader;
  background-color: $gray10;
  padding-bottom: 8px;
  margin-bottom: 8px;
  &:after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    transform: translateY(100%);
    height: 8px;
    background: linear-gradient(0deg, rgba($gray10, 0) 0%, $gray10 100%);
  }
}

.componentsRow {
  @extend .row;
  margin-top: 40px;
  & > div {
    @extend .col-xs-6;
  }
}

.warningOption {
  color: $warning900 !important;
}

.alertOption {
  color: $error900 !important;
}

.deadlineMissedOption {
  color: $corral !important;
}
